import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Logo from 'components/ui/logo/logo';
import LoginFacilitatorController from './login-facilitator/login-facilitator-controller';
import ResetPassword from './reset-password/reset-password';
import './login.scss';

const Login = ({languageId, gameData}) => {
	/* Get active box component for facilitator box */
	let [showResetPassword, setShowResetPassword] = useState(false);
	
	/* Get login component */
	let LoginComponent = LoginFacilitatorController;
	if (showResetPassword) LoginComponent = ResetPassword;
	
	return (
		<div className="Login">
			{/* Login */}
			<LoginComponent 
				languageId={languageId} 
				setShowResetPassword={setShowResetPassword} 
			/>

			{/* CGL logo */}
			<div className="Login-logoCGL"><Logo type="cgl"/></div>			
		</div>
	);
};

Login.propTypes = {
	languageId: PropTypes.string.isRequired,
	gameData: PropTypes.object
};

export default Login;